import "./main_dashboard.css";
import Top_navbar from "./Top_navbar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard } from '@fortawesome/free-regular-svg-icons';

import { useNavigate } from "react-router-dom";
import { usePermissions } from "../../controllers/PermissionContext";
import { useEffect } from "react";
import { getFCMToken } from "../../config/firebase";
import { updateDeviceToken } from "../../controllers/V1/users/usersController";

const Dashboard = () => {
 const navigate = useNavigate();
 const {fullAccess, permissions} = usePermissions("FULL");
  useEffect(() => {
    const initializeNotifications = async () => {
      try {
        // Request notification permission
        const permission = await Notification.requestPermission();
        
        if (permission === "granted") {
          // Get FCM token
          const token = await getFCMToken();
          const user = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));
          if(user?.web_device_id !== token){
            // console.log('user----------------',user);
            if (token) {
              // Send token to backend
              const result = await updateDeviceToken(token);
              if (result.status) {
                console.log('Device token updated successfully');
              } else {
                console.error('Failed to update device token:', result.message);
              }
            } else {
              console.error('Failed to get FCM token');
            }
          }
        } else {
          // Otherwise, we can fallback to a regular alert
          alert("You need to allow notifications to use notification feature.");
        }
      } catch (error) {
        console.error('Error initializing notifications:', error);
      }
    };

    // Only initialize if user is authenticated
    const token = sessionStorage.getItem("TOKEN");
    if (token) {
      initializeNotifications();
    }
  }, []);
  return (
    <>
      <Top_navbar></Top_navbar>
      <div className="container-fluid">
        <div className="row">
          
          {(permissions?.customer_due?.customer_list === "Y" || fullAccess === "Y") && (
            <div className="col-md-3 px-0" onClick={()=>navigate('/customers-due/list')}>
            <div className="transaction_form">
              <div className="transaction_Card margin-right">
                <span style={{marginLeft:'10px',marginRight:'10px'}}>  <FontAwesomeIcon icon={faCreditCard} className="sidebar_collapse_iohomeoutline" /></span>
                <div className="transction_main_Card ">
                  <h1 className="dashboard_top_heading_user"> Customer's Due</h1>
                </div>
                <p className="presentation my-2">
                  Navigate to customer's due list
                </p>
              </div>
            </div>
          </div>
          )}

          {(permissions?.invoice?.individual === "Y" || fullAccess === "Y") && (
          <div className="col-md-3 px-0" onClick={()=>navigate('/invoice/list')}>
            <div className="transaction_form">
              <div className="transaction_Card margin-right">
                <span style={{marginLeft:'10px',marginRight:'10px'}}>  <FontAwesomeIcon icon={faCreditCard} className="sidebar_collapse_iohomeoutline" /></span>
                <div className="transction_main_Card ">
                  <h1 className="dashboard_top_heading_user"> Individual Invoice</h1>
                </div>
                <p className="presentation my-2">
                  Navigate to individual invoice list
                </p>
              </div>
            </div>
          </div>
          )}

          {(permissions?.invoice?.bulk_request === "Y" || fullAccess === "Y") && (
          <div className="col-md-3 px-0"onClick={()=>navigate('/invoice/request')}>
            <div className="transaction_form">
              <div className="transaction_Card margin-right">
                <span style={{marginLeft:'10px',marginRight:'10px'}}>  <FontAwesomeIcon icon={faCreditCard} className="sidebar_collapse_iohomeoutline" /></span>
                <div className="transction_main_Card ">
                  <h1 className="dashboard_top_heading_user"> Bulk Invoice request</h1>
                </div>
                <p className="presentation my-2">
                  Navigate to bulk invoice request list
                </p>
              </div>
            </div>
          </div>
          )}

          {(permissions?.transaction?.list === "Y" || fullAccess === "Y") && (
          <div className="col-md-3 px-0"onClick={()=>navigate('/transaction/list')}>
            <div className="transaction_form">
              <div className="transaction_Card margin-right">
                <span style={{marginLeft:'10px',marginRight:'10px'}}>  <FontAwesomeIcon icon={faCreditCard} className="sidebar_collapse_iohomeoutline" /></span>
                <div className="transction_main_Card ">
                  <h1 className="dashboard_top_heading_user"> Transactions</h1>
                </div>
                <p className="presentation my-2">
                  Navigate to transaction list
                </p>
              </div>
            </div>
          </div>
          )}

          {(permissions?.analyser?.list === "Y" || fullAccess === "Y") && (  
          <div className="col-md-3 px-0"onClick={()=>navigate('/analyser')}>
            <div className="transaction_form">
              <div className="transaction_Card margin-right">
                <span style={{marginLeft:'10px',marginRight:'10px'}}>  <FontAwesomeIcon icon={faCreditCard} className="sidebar_collapse_iohomeoutline" /></span>
                <div className="transction_main_Card ">
                  <h1 className="dashboard_top_heading_user"> Analyser</h1>
                </div>
                <p className="presentation my-2">
                  Navigate to winner's analyser
                </p>
              </div>
            </div>
          </div>
          )}
          {(permissions?.winnerVoucher?.list === "Y" || fullAccess === "Y") && (
            <div className="col-md-3 px-0"onClick={()=>navigate('/winners/list')}>
              <div className="transaction_form">
                <div className="transaction_Card margin-right">
                  <span style={{marginLeft:'10px',marginRight:'10px'}}>  <FontAwesomeIcon icon={faCreditCard} className="sidebar_collapse_iohomeoutline" /></span>
                  <div className="transction_main_Card ">
                    <h1 className="dashboard_top_heading_user"> Winner's Voucher</h1>
                  </div>
                  <p className="presentation my-2">
                    Navigate to winner's voucher list
                  </p>
                </div>
              </div>
            </div>
          )}
          {(permissions?.userRequest?.list === "Y" || fullAccess === "Y") && (
            <div className="col-md-3 px-0"onClick={()=>navigate('/users/request-list')}>
              <div className="transaction_form">
                <div className="transaction_Card margin-right">
                  <span style={{marginLeft:'10px',marginRight:'10px'}}>  <FontAwesomeIcon icon={faCreditCard} className="sidebar_collapse_iohomeoutline" /></span>
                  <div className="transction_main_Card ">
                    <h1 className="dashboard_top_heading_user"> User Request</h1>
                  </div>
                  <p className="presentation my-2">
                    Navigate to user request list
                  </p>
                </div>
              </div>
            </div>
          )}
          {(permissions?.userPullOutRequest?.list === "Y" || fullAccess === "Y") && (
            <div className="col-md-3 px-0"onClick={()=>navigate('/request/pull-out-list')}>
              <div className="transaction_form">
                <div className="transaction_Card margin-right">
                  <span style={{marginLeft:'10px',marginRight:'10px'}}>  <FontAwesomeIcon icon={faCreditCard} className="sidebar_collapse_iohomeoutline" /></span>
                  <div className="transction_main_Card ">
                    <h1 className="dashboard_top_heading_user"> User Pull Out Request</h1>
                  </div>
                  <p className="presentation my-2">
                    Navigate to user pull out request list
                  </p>
                </div>
              </div>
            </div>
          )}
          {(permissions?.notification?.list === "Y" || fullAccess === "Y") && (
            <div className="col-md-3 px-0"onClick={()=>navigate('/notifications/list')}>
              <div className="transaction_form">
                <div className="transaction_Card margin-right">
                  <span style={{marginLeft:'10px',marginRight:'10px'}}>  <FontAwesomeIcon icon={faCreditCard} className="sidebar_collapse_iohomeoutline" /></span>
                  <div className="transction_main_Card ">
                    <h1 className="dashboard_top_heading_user"> Notification</h1>
                  </div>
                  <p className="presentation my-2">
                    Navigate to notification list
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      
      </div>
    </>
  );
};

export default Dashboard;
